import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,

  //for header
  headerStartColor: '#2a2e36',
  headerEndColor: '#2a2e36',
  headerTitle: '#fff',
  headerBackIcon: '#fff',

  //for header timer
  headerTimerTeamNameText: 'white',
  headerTimerTeamLogoBorder: 'white',
  headerTimerText: 'white',

  //for text input 3
  textInputBG: constants.Colors.DarkPurple,
  textInputColor: constants.Colors.LightGreyBlue,
  textInputPlaceHolder: constants.Colors.LightGreyBlue,
  textInputInfo: constants.Colors.WildBlueYonder,
  textInputSelection: constants.Colors.White,
  textInputPrimary: '#ffffff',
  textInputAccent: '#f1c40f',

  //for toggle visible icon
  toggleVisibleIcon: '#8b90a0',

  //for update download progress
  updateDownloadContainer: 'rgba(0,0,0,0.6)',
  updateDownloadSubContainer: 'rgba(0,0,0,0.4)',
  updateDownloadShadow: 'rgba(0,0,0,0.4)',
  updateDownloadTitle: 'white',

  //for bottom sheet
  bottomSheetHeaderStart: '#182152',
  bottomSheetHeaderEnd: '#182152',
  bottomSheetHeaderBtn: constants.Colors.White,

  //for team filter
  teamFilterBackground: constants.Colors.RegalBlue,
  teamFilterTitle: constants.Colors.White,
  teamFilterContentTitle: constants.Colors.White,
  teamFilterContentBorder: constants.Colors.WildBlueYonder,
  teamFilterContentValue: constants.Colors.White,
  teamFilterChecked: constants.Colors.Lime,
  teamFilterUnChecked: constants.Colors.WildBlueYonder,

  //for recent match
  recentMatchTitle: constants.Colors.White,

  //for placeholder
  placeholderBackground: constants.Colors.DarkBlue1,
  placeholderAnimationBackground: constants.Colors.newBackground,

  //for banner indicator
  bannerIndicator: 'rgba(255, 255, 255, 0.92)',

  // for profile info
  profileInfoContainer: '#040628',
  profileInfoNameTitle: '#fff',
  profileInfoEmailTitle: '#fff',
  profileInfoTeamNameTitle: '#fff',
  profileInfoMobileTitle: '#fff',
  profileInfoDivider: '#202954',

  // for playing history
  playingHistoryContainerBG: '#040628',
  playingHistoryTitle: '#8993a8',
  playingHistoryValue: '#fff',

  //for verify phone item
  verifyAccountItemContainer: '#040628',
  verifyAccountItemContainerBorder: '#00df76',
  verifyAccountItemHeaderContainer: '#040628',
  verifyAccountItemTitle: '#fff',
  verifyAccountItemVerified: '#00df76',
  verifyAccountItemPending: '#ffd459',
  verifyAccountItemRejected: '#f6324b',
  verifyAccountItemDeleteIcon: '#f6324b',
  verifyAccountItemBtnVerifyBtnBG: 'transparent',
  verifyAccountItemBtnVerifyBtnLabel: '#f6324b',
  verifyAccountItemBtnVerifyBtnBorder: '#f6324b',
  verifyAccountItemInputBG: '#040628',
  verifyAccountItemInputPlaceHolder: '#818393',
  verifyAccountItemEnterCode: '#fff',
  verifyAccountItemBottomBtnBG: '#f6324b',
  verifyAccountItemBottomBtnBorder: '#f6324b',
  verifyAccountItemBottomBtnLabel: '#fff',
  verifyAccountItemInputText: '#ffffff',
  verifyAccountItemInputPrimary: '#ffffff',
  verifyAccountItemPlaceholder: constants.Colors.LightGreyBlue,
  verifyAccountItemContent: '#1f2a54',
  verifyAccountItemImageUploadIcon: '#040628',
  verifyAccountItemImageUploadBtn: '#040628',
  verifyAccountItemImageUploadBtnLabel: '#fff',
  verifyAccountItemImageUploadBtnBorder: '#f6324b',
  verifyAccountItemInfoText: '#8f95a9',
  verifyAccountItemErrorText: '#f6324b',

  //for server down
  serverDownHeader: '#040628',
  serverDownHeaderTitle: '#fff',
  serverDownContent: '#fff',
  serverDownButtonBG: '#040628',
  serverDownButtonTitle: '#fff',

  //for restriction message
  restrictionMessageTitle: '#fff',

  //for substitute game rule
  substituteGameRuleMainContainer: '#182152',
  substituteGameRuleContainer: '#fff',
  substituteGameRuleHeaderContainer: '#182152',
  substituteGameRuleHeaderTitle: '#182152',
  substituteGameRuleCloseBtn: '#fff',
  substituteGameRuleCloseBtnTitle: '#005089',
  substituteGameRuleTitle: '#1a1f3f',

  //for set team name modal
  teamNameBG: '#1f2a54',
  setTeamHeaderTitle: '#fff',
  setTeamVerticalDivider: '#fff',
  setTeamTextInputBG: '#fff',
  setTeamLoader: '#fff',
  setTeamTextInputTitle: '#040628',
  setTeamTextInputPlaceholder: '#1f2a54',
  setTeamTextInputBorder: 'transparent',
  setTeamTextInputError: '#f00',
  setTeamNote: '#fff',
  setTeamCloseBtn: '#fff',
  setTeamSubmitBtnBG: '#005089',
  setTeamSubmitBtnTitle: '#fff',

  // for countdown timer
  countDownTimerDeadlineBG: '#005089',
  countDownTimerDeadlineMessage: '#fff',
  countDownTimerDeadlineBtn: '#fff',
  countDownTimerDeadlineBtnTitle: '#1a1f3f',

  //for geo fence
  geoFenceCardBG: '#fff',
  geoFenceCardTitle: '#1a1f3f',
  geoFenceCardMessage: '#1a1f3f',
  geoFenceCardBtn: '#005089',
  geoFenceCardBtnTitle: '#fff',

  //for mini games
  miniGamesIcon: 'white',
  miniGamesText: 'white',
  miniGamesBtnBG: '#252d58',

  //for banner
  bannerBG: '#1a1f3f',

  // PaginationIndicator
  paginationIndicator: '#fff',

  //for feedback
  feedbackSubmitBtn: '#f6324b',
  feedbackSubmitBtnLabel: '#fff',
  feedbackModalBG: '#06082a',
  feedbackTextInputBG: constants.Colors.DarkPurple,
  feedbackTextInputColor: constants.Colors.White,
  feedbackOptions: 'white'
};
